import { createAction, props } from '@ngrx/store';
import {
  Stock,
  Sector,
  Template,
  TemplateProperty,
  PaginationState,
} from '../../models/stock.model';

// Load Stocks
export const loadStocks = createAction(
  '[Stocks] Load Stocks',
  props<{
    filters?: { searchTerm?: string; pageNumber?: number; pageSize?: number; sectorId?: string } | undefined;
  }>()
);
export const loadStocksSuccess = createAction(
  '[Stocks] Load Stocks Success',
  props<{
    stocks: Stock[];
    pagination: PaginationState;
  }>()
);
export const loadStocksFailure = createAction(
  '[Stocks] Load Stocks Failure',
  props<{ error: any }>()
);

// Load Single Stock
export const loadStock = createAction('[Stock] Load Stock', props<{ id: string }>());

export const loadStockSuccess = createAction(
  '[Stock] Load Stock Success',
  props<{ stock: Stock }>()
);

export const loadStockFailure = createAction('[Stock] Load Stock Failure', props<{ error: any }>());

// Create Stock
export const createStock = createAction('[Stocks] Create Stock', props<{ stock: FormData }>());
export const createStockSuccess = createAction(
  '[Stocks] Create Stock Success',
  props<{ stock: Stock }>()
);
export const createStockFailure = createAction(
  '[Stocks] Create Stock Failure',
  props<{ error: any }>()
);

// Update Stock
export const updateStock = createAction(
  '[Stocks] Update Stock',
  props<{ stockId: string; stock: FormData }>()
);
export const updateStockSuccess = createAction(
  '[Stocks] Update Stock Success',
  props<{ stock: Stock }>()
);
export const updateStockFailure = createAction(
  '[Stocks] Update Stock Failure',
  props<{ error: any }>()
);

// Delete Stock
export const deleteStock = createAction('[Stocks] Delete Stock', props<{ id: string }>());
export const deleteStockSuccess = createAction(
  '[Stocks] Delete Stock Success',
  props<{ id: string }>()
);
export const deleteStockFailure = createAction(
  '[Stocks] Delete Stock Failure',
  props<{ error: any }>()
);

// Activate Stock
export const activateStock = createAction('[Stocks] Activate Stock', props<{ id: string }>());
export const activateStockSuccess = createAction(
  '[Stocks] Activate Stock Success',
  props<{ id: string }>()
);
export const activateStockFailure = createAction(
  '[Stocks] Activate Stock Failure',
  props<{ error: any }>()
);

// Deactivate Stock
export const deactivateStock = createAction('[Stocks] Deactivate Stock', props<{ id: string }>());
export const deactivateStockSuccess = createAction(
  '[Stocks] Deactivate Stock Success',
  props<{ id: string }>()
);
export const deactivateStockFailure = createAction(
  '[Stocks] Deactivate Stock Failure',
  props<{ error: any }>()
);

// Load Sectors
export const loadSectors = createAction('[Companies] Load Sectors');
export const loadSectorsSuccess = createAction(
  '[Companies] Load Sectors Success',
  props<{ sectors: Sector[] }>()
);
export const loadSectorsFailure = createAction(
  '[Companies] Load Sectors Failure',
  props<{ error: any }>()
);

// Load Templates
export const loadTemplates = createAction('[Companies] Load Templates');
export const loadTemplatesSuccess = createAction(
  '[Companies] Load Templates Success',
  props<{ templates: Template[] }>()
);
export const loadTemplatesFailure = createAction(
  '[Companies] Load Templates Failure',
  props<{ error: any }>()
);

// Load Markets
export const loadMarkets = createAction('[Companies] Load Markets');
export const loadMarketsSuccess = createAction(
  '[Companies] Load Markets Success',
  props<{ markets: any[] }>()
);
export const loadMarketsFailure = createAction(
  '[Companies] Load Markets Failure',
  props<{ error: any }>()
);

// Load Industries
export const loadIndustries = createAction('[Companies] Load Industries');
export const loadIndustriesSuccess = createAction(
  '[Companies] Load Industries Success',
  props<{ industries: any[] }>()
);
export const loadIndustriesFailure = createAction(
  '[Companies] Load Industries Failure',
  props<{ error: any }>()
);

// Load Template Properties
export const loadTemplateProperties = createAction(
  '[Companies] Load Template Properties',
  props<{ templateId: string; category: string }>()
);
export const loadTemplatePropertiesSuccess = createAction(
  '[Companies] Load Template Properties Success',
  props<{ properties: TemplateProperty[] }>()
);
export const loadTemplatePropertiesFailure = createAction(
  '[Companies] Load Template Properties Failure',
  props<{ error: any }>()
);

// Load Settings
export const loadSettings = createAction('[Companies] Load Settings');
export const loadSettingsSuccess = createAction(
  '[Companies] Load Settings Success',
  props<{ settings: any }>()
);
export const loadSettingsFailure = createAction(
  '[Companies] Load Settings Failure',
  props<{ error: any }>()
);
